import { gql } from "@apollo/client";

export const CASCO_QUOTATIONS_HISTORY_QUERY = gql`
  query cascoQuotationsHistory($documentId: Int!) {
    cascoQuotationsHistory(documentId: $documentId) {
      conventionName
      insurerName
      period
      baseInsuranceAmount
      totalInsuranceAmount
      totalDamageDeductiblePercent
      partialDamageDeductibleAmount
      discountAmount
      discountPercent
      periodicity
      insuredAmount
      quotationDate
      risks {
        riskName
        selected
      }
      coefficients {
        additionalDataName
        details {
          detailName
          selected
        }
      }
    }
  }
`;

export const HAS_CASCO_QUOTATIONS_HISTORY_QUERY = gql`
  query hasCascoQuotationsHistory($documentId: Int!) {
    hasCascoQuotationsHistory(documentId: $documentId)
  }
`;
